var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "md-dialog",
    {
      attrs: { "md-active": _vm.showBool },
      on: {
        "update:mdActive": function ($event) {
          _vm.showBool = $event
        },
        "update:md-active": function ($event) {
          _vm.showBool = $event
        },
      },
    },
    [
      _c("md-dialog-title", [_vm._v(_vm._s(_vm.t("app-are-you-sure")))]),
      _vm._v(" "),
      _c("md-dialog-content", [
        _vm._v(_vm._s(_vm.t("app-are-you-sure-you-want-to-delete")) + " "),
        _vm.filter
          ? _c("i", [_vm._v(_vm._s(_vm.filter.attributes.title))])
          : _vm._e(),
        _vm._v(". "),
        _c("b", [_vm._v(_vm._s(_vm.t("app-cannot-be-undone")))]),
      ]),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: {
                click: function ($event) {
                  _vm.showBool = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.t("app-cancel")))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: {
                click: function ($event) {
                  _vm.showBool = false
                  _vm.$emit("delete", _vm.filter)
                },
              },
            },
            [_vm._v(_vm._s(_vm.t("app-delete")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }